import { createSelector } from "reselect"
import { find, last } from "lodash"
import { computeData, getAllCategoryItems } from "modules/analyze-composite-composition/selectors/data"
import { getSelectedContributorCategoryId } from "helpers/compositeSecuritiesDetails"

const getBeta = (_, props) => props.beta
const getSelectedDate = (_, props) => props.selectedDate

const getContributorData = createSelector(
  [getAllCategoryItems, getBeta],
  (items, beta) => computeData(items, beta),
)

const getLastContributor = createSelector(
  [getContributorData],
  (data) => last(data),
)

export const getSelectedContributorCategory = createSelector(
  [getSelectedContributorCategoryId, getAllCategoryItems],
  (selected, items) => {
    if (!selected) {
      return selected
    }

    const found = find(items, d => d.id === selected)
    if (found) {
      return found
    } else {
      return null
    }
  },
)

export const getDetails = createSelector(
  [getContributorData, getSelectedDate, getAllCategoryItems, getLastContributor],
  (data, date, items, lastContributor) => {
    let dayData = {}

    if (lastContributor) {
      if (date === lastContributor.date.format("YYYY-MM-DD")) {
        dayData = lastContributor
      } else {
        const contributor = find(data, day => date === day.date.format("YYYY-MM-DD"))
        if (contributor) {
          dayData = contributor
        }
      }
    }

    return items
      .map(item => ({
        label: item.label,
        id: item.id,
        value: dayData[item.id],
        color: item.color,
        category: item.category,
        field: item.field,
        tooltip: item.tooltip,
      }))
      .filter(item => item.value)
  },
)

export const getSelectedContributorValue = createSelector(
  [getDetails, getSelectedContributorCategory],
  (contributors, selected) => {
    if (!selected) {
      return 0
    }

    const item = find(contributors, d => d.id === selected.id)
    if (item) {
      return item.value
    } else {
      return 0
    }
  },
)
